<template>
    <div>
        <b-overlay :opacity="overlay.opacity" :show="overlay.visible" rounded="sm">
            <b-container class="mt-3" fluid>
                <!-- table toolbar -->
                <table-toolbar
                    :columns-filter="tableToolbarColumns"
                    :columns-show="tableToolbarColumns"
                    :locale-key="localeKey"
                    :options="tableToolbar.options"
                    :response.sync="tableToolbar.response"
                    @eventNew="toolbarTableEventNew"
                    @eventRefresh="toolbarTableEventRefresh"
                ></table-toolbar>
                <!-- table -->
                <b-table
                    id="main-table"
                    :current-page="tableToolbar.options.pagination.currentPage"
                    :fields="tableColumns"
                    :filter="tableToolbar.response.filter === undefined ? null : tableToolbar.response.filter.search"
                    :filterIncludedFields="tableToolbar.response.filter === undefined ? null : tableToolbar.response.filter.columnsOn"
                    :items="tableItems"
                    :per-page="tableToolbar.options.pagination.perPage"
                    :sort-by.sync="table.sortBy"
                    :sort-desc.sync="table.sortDesc"
                    bordered head-row-variant="dark" hover outlined
                    responsive="sm"
                    striped
                    table-class="text-center"
                    table-variant="light"
                    @filtered="onFiltered"
                >
                    <!-- name -->
                    <template v-slot:cell(name)="row">
                        <div class="d-flex justify-content-start">
                            {{row.item.name}}
                        </div>
                    </template>
                    <!-- stamp -->
                    <template v-slot:cell(stamp)="row">
                        <div class="d-flex justify-content-start">
                            {{row.item.stamp}}
                        </div>
                    </template>
                    <!-- active -->
                    <template v-slot:cell(active)="row">
                        <div class="d-flex justify-content-around">
                            <b-icon-sun
                                :variant="row.item.active ? 'success' : 'danger'"
                                scale="1.2"
                            ></b-icon-sun>
                        </div>
                    </template>
                    <!-- actions -->
                    <template v-slot:cell(action)="row">
                        <div class="d-flex justify-content-around">
                            <!-- detail show -->
                            <b-icon-caret-down-square
                                v-if="!row.detailsShowing"
                                v-b-tooltip.hover
                                :title="$t('form.detail_show')"
                                scale="1.2"
                                style="cursor: pointer; margin-right: 3px;"
                                variant="secondary"
                                @click="row.toggleDetails"
                            ></b-icon-caret-down-square>
                            <!-- detail hide -->
                            <b-icon-caret-up-square-fill
                                v-if="row.detailsShowing"
                                v-b-tooltip.hover
                                :title="$t('form.detail_hide')"
                                scale="1.2"
                                style="cursor: pointer; margin-right: 3px;"
                                variant="secondary"
                                @click="row.toggleDetails"
                            ></b-icon-caret-up-square-fill>
                            <!-- edit -->
                            <b-icon-file-text
                                v-if="!row.item.system"
                                v-b-tooltip.hover
                                :title="$t('form.edit')"
                                scale="1.2"
                                style="cursor: pointer; margin-right: 3px;"
                                variant="secondary"
                                @click="recordEdit(row.item)"
                            ></b-icon-file-text>
                            <!-- delete -->
                            <b-icon-trash
                                v-if="!row.item.system"
                                v-b-tooltip.hover
                                :title="$t('form.delete')"
                                scale="1.2"
                                style="cursor: pointer;"
                                variant="danger"
                                @click="recordDelete(row.item)"
                            ></b-icon-trash>
                        </div>
                    </template>
                    <!-- row detail -->
                    <template v-slot:row-details="row">
                        <TableDetailHtml :content="tableRowDetail(row.item.id)"></TableDetailHtml>
                    </template>
                </b-table>
                <!-- pagination -->
                <b-pagination
                    v-model="tableToolbar.options.pagination.currentPage"
                    :per-page="tableToolbar.options.pagination.perPage"
                    :total-rows="this.tableToolbar.options.filterCount"
                    aria-controls="main-table"
                    limit="20"
                    size="sm"
                ></b-pagination>
            </b-container>
        </b-overlay>
        <!-- modalFormXxx -->
        <ModalFormAccess
            :form="form"
            :locale-key="localeKey"
            :uri="uri"
            @refresh="modalEventRefresh"
        ></ModalFormAccess>
    </div>
</template>

<script>
import TableToolbar from "@/components/general/elements/tableAccessories/TableToolbar";
import TableDetailHtml from "@/components/general/elements/tableAccessories/TableDetailHtml";
import ModalFormAccess from "@/components/admin/access/ModalFormAccess";

export default {
    name: "Accesses",
    components: {ModalFormAccess, TableDetailHtml, TableToolbar},
    props: {},
    data() {
        return {
            overlay: {
                visible: false,
                opacity: 0.7,
            },
            localeKey: 'admin.access.main',
            uri: {
                main: `api/v1/admin/accesses`,
                uri1: `api/v1/admin/access`,
            },
            table: {
                items: [],
                fields: [],
                columns: [
                    {
                        key: 'id',
                        label: this.$t('form.id'),
                        sortable: true,
                        show: true,
                    },
                    {
                        key: 'stamp',
                        label: this.$t('form.stamp'),
                        sortable: true,
                        show: true
                    },
                    {
                        key: 'name',
                        label: this.$t('form.name'),
                        sortable: true,
                        alwaysShow: true,
                    },
                    {
                        key: 'order',
                        label: this.$t('form.order'),
                        sortable: true,
                        show: true,
                    },
                    {
                        key: 'active',
                        label: this.$t('form.active'),
                        sortable: true,

                    },
                ],
                sortBy: 'id',
                sortDesc: false,
            },
            tableToolbar: {
                options: {
                    filterCount: 0,
                    rowsCount: 0,
                    pagination: {
                        perPage: 10,
                        currentPage: 1,
                    },
                },
                response: {}
            },
            form: {},
            // <-- set -->
            data: [],
        }
    },
    mounted() {
        this.baseSelect();
    },
    methods: {
        showOverlay(show) {
            this.overlay.visible = show;
        },
        // <-- toolbarTable -->
        toolbarTableEventRefresh() {
            this.baseSelect();
        },
        toolbarTableEventNew() {
            this.recordNew();
        },
        // <-- modalForm -->
        modalEventRefresh(data) {
            this.$set(this, 'data', data);
        },
        // <-- table -->
        onFiltered(filteredItems) {
            this.tableToolbar.options.filterCount = filteredItems.length;
            this.tableToolbar.options.pagination.currentPage = 1;
        },
        tableRowDetail(id) {
            let record = this.data.records.find((n) => {
                if (n.id === id) {
                    return n;
                }
            });
            if (record.locale[this.$i18n.locale] !== undefined) {
                return record.locale[this.$i18n.locale].notes;
            }
        },
        // <-- record -->
        recordNew() {
            this.$set(this.form, 'id', 0);
            this.$bvModal.show('ModalFormAccess');
        },
        recordEdit(row) {
            this.$set(this.form, 'id', row.id);
            this.$bvModal.show('ModalFormAccess');
        },
        recordDelete(row) {
            const h = this.$createElement;
            const messageHTML = h('div', [
                h('span', [
                    `${this.$t('form.delete_message.pre')} ${this.$tc(this.localeKey, 2)} `,
                    h('strong', row.name), this.$t('form.delete_message.post'),
                ])
            ]);
            // <-- message box -->
            this.$bvModal.msgBoxConfirm([messageHTML], {
                title: this.$t('form.please_confirm'),
                // size: 'sm',
                // buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: this.$t('form.delete'),
                cancelTitle: this.$t('form.cancel'),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value) {
                        this.baseDelete(row.id);
                    }
                })
                .catch(err => {
                    // on error executed
                })
        },
        // <-- api calls -->
        baseSelect: function () {
            this.showOverlay(true);
            // <-- api -->
            const config = {
                headers: this.__getHeaders()
            };
            // <-- axios -->
            this.axios.get(this.uri.main, config)
                .then((response) => {
                    this.$set(this, 'data', response.data);
                    this.showOverlay(false);
                })
                .catch((error) => {
                    // console.log("ERROR:", error.response.data);
                    this.showOverlay(false);
                });
        },
        baseDelete(record_id) {
            this.showOverlay(true);
            // <-- api -->
            const config = {
                headers: this.__getHeaders()
            };
            // <-- axios -->
            this.axios.delete(this.uri.main + `/${record_id}`, config)
                .then((response) => {
                    this.data = response.data;
                    this.showOverlay(false);
                })
                .catch((error) => {
                    // console.log("error:", error);
                })
                .finally(function () {
                    // always executed
                });
        },
    },
    computed: {
        // <-- tableToolbar -->
        tableToolbarColumns() {
            let columns = this.table.columns;
            // <-- check if exists -->
            if (columns === undefined) {
                return [];
            }
            // <--  -->
            let values = [];
            columns.forEach(column => {
                values.push({
                    key: column.key,
                    label: column.label,
                    sortable: column.sortable,
                    show: column.show,
                    alwaysShow: column.alwaysShow
                });
            });
            // <--  -->
            return values;
        },
        // <-- table -->
        tableColumns() {
            let columns = this.table.columns;
            let columnsShow = this.tableToolbar.response.columnsShow;
            // <-- check if exists -->
            if (columns === undefined) {
                return [];
            }
            // <--  -->
            let values = [];
            columns.forEach(column => {
                if (column.alwaysShow || (columnsShow != null && columnsShow.indexOf(column.key) >= 0)) {
                    values.push({
                        key: column.key,
                        label: column.label,
                        sortable: column.sortable,
                        show: column.show,
                    });
                }
            });
            // <-- add column actions -->
            values.push({
                key: 'action',
                label: '',
                id: 0,
                sortable: false,
                thStyle: {width: '90px'}    //85
                // variant: 'danger',
            });
            // <--  -->
            return values;
        },
        tableItems() {
            if (this.data.records === undefined) {
                return [];
            }
            // <--  -->
            let records = this.data.records;
            // <-- check if exists -->
            if (records.length === 0) {
                return [];
            }
            // <--  -->
            let items = [];
            let item = {};
            let name, notes;
            records.forEach(record => {
                name = record.meta.name;
                notes = null;
                Object.keys(record.locale).find((n) => {
                    if (n === this.$i18n.locale) {
                        // <-- locale name -->
                        if (!this.__isNull(record.locale[n].name)) {
                            name = record.locale[n].name;
                        }
                        // <-- locale notes -->
                        if (!this.__isNull(record.locale[n].notes)) {
                            notes = record.locale[n].notes;
                        }
                    }
                });
                // <-- set item -->
                item = {
                    id: record.id,
                    name: name,
                    stamp: record.stamp,
                    order: record.order,
                    active: record.active,
                }
                items.push(item);
            });
            // <--  -->
            this.tableToolbar.options.filterCount = items.length;
            this.tableToolbar.options.rowsCount = items.length;
            return items;
        },
    },
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
